import { useEffect, useState } from "react";
import type { InvoiceData } from "@shared/invoice";
import type { InvoiceLayoutReport } from "@shared/invoice-layout";
import { invoiceToPDFData } from "@/lib/invoice-pdf";
import { PDFGenerator } from "@/lib/pdf-generator";

export type InvoiceLayoutCheck = {
  report?: InvoiceLayoutReport;
  checking: boolean;
  error?: string;
};

export function useInvoiceLayoutCheck(data: InvoiceData | null): InvoiceLayoutCheck {
  const [result, setResult] = useState<InvoiceLayoutCheck & { source?: InvoiceData }>({ checking: false });
  useEffect(() => {
    if (!data) return;
    let cancelled = false;
    const timer = window.setTimeout(() => {
      void Promise.resolve().then(() => new PDFGenerator().measureInvoiceLayout(invoiceToPDFData(data))).then(
        (report) => { if (!cancelled) setResult({ source: data, report, checking: false }); },
        () => { if (!cancelled) setResult({ source: data, checking: false,
          error: "Die Layoutprüfung ist fehlgeschlagen. Bitte Eingaben ändern oder die Rechnung erneut öffnen." }); },
      );
    }, 350);
    return () => { cancelled = true; window.clearTimeout(timer); };
  }, [data]);
  // Never present a previous invoice/edit as a successful current check.
  return result.source === data ? result : { checking: !!data };
}
